import { render, staticRenderFns } from "./WatchPolls.vue?vue&type=template&id=788e2577&scoped=true"
import script from "./WatchPolls.vue?vue&type=script&lang=js"
export * from "./WatchPolls.vue?vue&type=script&lang=js"
import style0 from "./WatchPolls.vue?vue&type=style&index=0&id=788e2577&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e2577",
  null
  
)

export default component.exports